import { render, staticRenderFns } from "./DesignConfig.vue?vue&type=template&id=02c2e158&"
import script from "./DesignConfig.vue?vue&type=script&lang=js&"
export * from "./DesignConfig.vue?vue&type=script&lang=js&"
import style0 from "./DesignConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports